import { JsonObject, JsonProperty } from 'json2typescript';
import { Attachment } from './attachment';

@JsonObject('Banner')
export class Banner {
  @JsonProperty('id', String)
  public id?: string = undefined;
  @JsonProperty('description', String)
  public description?: string = undefined;
  @JsonProperty('desktopAttachment', Attachment)
  public desktopAttachment?: Attachment = undefined;
  @JsonProperty('desktopAttachmentId', String)
  public desktopAttachmentId?: string = undefined;
  @JsonProperty('mobileAttachment', Attachment)
  public mobileAttachment?: Attachment = undefined;
  @JsonProperty('mobileAttachmentId', String)
  public mobileAttachmentId?: string = undefined;
  @JsonProperty('startDate', String)
  public startDate?: string = undefined;
  @JsonProperty('endDate', String)
  public endDate?: string = undefined;
  @JsonProperty('geoLocation', [String])
  public geoLocation?: string[] = undefined;
  @JsonProperty('operatingSectorList', [String])
  public operatingSectorList?: string[] = undefined;
  @JsonProperty('machineTypology', [String])
  public machineTypology?: string[] = undefined;
  @JsonProperty('articleTypology', String)
  public articleTypology?: string = undefined;
  @JsonProperty('roles', [String])
  public roles?: string[] = undefined;
  @JsonProperty('url', String)
  public url?: string = undefined;
  @JsonProperty('createdDate', String)
  public createdDate?: string = undefined;
  @JsonProperty('modifiedDate', String)
  public modifiedDate?: string = undefined;
}
